import { z } from "zod";

/** Isti obrazac koristi i admin picker linkova (FooterSettingsSection). */
export const SAFE_HREF_PATTERN = /^(\/[^/]|\/(?:$)|#|https?:\/\/|mailto:)/i;

const safeHref = z.string().max(500).refine(
  (val) => SAFE_HREF_PATTERN.test(val),
  { message: "Link mora počinjati sa /, #, http://, https:// ili mailto:" }
);

const i18nText = z.object({
  bs: z.string().max(500),
  en: z.string().max(500),
});

const footerLink = z.object({
  label: i18nText,
  href: safeHref,
});

const footerColumn = z.object({
  title: i18nText,
  links: z.array(footerLink).max(15),
});

const socialPlatform = z.enum([
  "instagram",
  "facebook",
  "linkedin",
  "x",
  "youtube",
  "tiktok",
]);

const footerSocial = z.object({
  platform: socialPlatform,
  url: z
    .string()
    .max(500)
    .refine((val) => /^https?:\/\//i.test(val), {
      message: "Link mora počinjati sa http:// ili https://",
    }),
});

const footerMerchant = z.object({
  title: i18nText,
  lines: z.array(i18nText).max(12),
});

export const footerConfigSchema = z.object({
  columns: z.array(footerColumn).min(1).max(6),
  description: i18nText,
  copyright: i18nText,
  socials: z.array(footerSocial).max(6).optional().default([]),
  merchant: footerMerchant.optional(),
});
